import commonreducer from './commonreducer';
import formreducer from '../../scenes/form/data/reducers';

const reducers = {
  commonreducer,
  formreducer,
};

export default reducers;
